import "../components/PhotoSet"
import { API_ENDPOINT } from "../constants";
import PrettyNaoAnalytics from "../service/AnalyticsService";
import "../service/FirebaseAndFreedomCRMService"

async function loadUserStatus() {
  const res = await fetch(`${API_ENDPOINT}/user/status`, { credentials: "include" });
  if (!res.ok) return;

  const { plan, points } = await res.json();

  const planBadge = document.getElementById("user-plan-label");
  const joinBtn = document.getElementById("join-plan-cta");
  const pointsLabel = document.getElementById("points-balance");

  if (plan) {
    //planBadge.classList.remove("hidden");
    //planBadge.textContent = `Plan: ${plan}`;
    joinBtn.classList.add("hidden");
  } else {
    //planBadge.classList.add("hidden");
    joinBtn.classList.remove("hidden");
  }

  pointsLabel.textContent = points || 0;
}

window.addEventListener('DOMContentLoaded', () => {
  PrettyNaoAnalytics.getPlausible()

  loadUserStatus();

  function setLangCookie(lang: string) {
    document.cookie = `preferred_lang=${lang}; path=/; max-age=31536000`; // 1 year
  }

  function getLangCookie(): string | null {
    const match = document.cookie.match(/(?:^|; )preferred_lang=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  document.getElementById('lang-switcher')?.addEventListener('change', (e) => {
    const lang = (e.target as HTMLSelectElement).value;
    const path = window.location.pathname.replace(/^\/es/, '');

    setLangCookie(lang)

    if (lang === 'es') {
      window.location.href = '/es' + path;
    } else {
      window.location.href = path;
    }
  });

  const cookieLang = getLangCookie();
  if (cookieLang) {
    const selector = document.getElementById('lang-switcher') as HTMLSelectElement;
    if (selector) selector.value = cookieLang;
  }

  (function redirectBasedOnLang() {
    const langCookie = document.cookie.match(/(?:^|; )preferred_lang=([^;]*)/);
    const preferredLang = langCookie ? langCookie[1] : null;

    const userLang = preferredLang || (navigator.language || navigator.userLanguage).split('-')[0]; // 'en' or 'es'
    const path = window.location.pathname;

    if (userLang === 'es' && !path.startsWith('/es')) {
      window.location.href = '/es' + path;
    } else if (userLang === 'en' && path.startsWith('/es')) {
      window.location.href = path.replace(/^\/es/, '');
    }
  })();

  document.addEventListener('purchase-complete', () => {
    loadUserStatus();
  })

});

